export const hybridApplication = {
  initial: 'validateContext',
  states: {
    validateContext: {
      always: [
        {
          target: 'initialize',
          cond: 'isHybridApplication',
        },
        {
          target: 'final',
        },
      ],
    },
    initialize: {
      invoke: {
        src: 'initializeHybridApplication',
        onDone: {
          target: 'requestPushNotifications',
        },
      },
    },
    requestPushNotifications: {
      invoke: {
        src: 'enablePushNotifications',
        onDone: {
          target: 'ready',
        },
      },
    },
    ready: {
      id: 'ready',
      on: {
        SESSION_STATE_LOGGED_IN: {
          target: 'loggedIn',
        },
      },
    },
    loggedIn: {
      type: 'parallel',
      on: {
        SESSION_STATE_LOGGED_OUT: {
          target: '#ready',
        },
      },
      states: {
        setUserAlias: {
          invoke: {
            src: 'setUserAlias',
          },
          type: 'final',
        },
        rateMe: {
          initial: 'incrementLoginCount',
          states: {
            incrementLoginCount: {
              invoke: {
                src: 'incrementLoginCount',
                onDone: {
                  target: 'checkCondition',
                  actions: ['updateLoginCount'],
                },
              },
            },
            checkCondition: {
              always: [
                {
                  target: 'showRateMe',
                  cond: 'shouldShowRateMe',
                },
                {
                  target: 'skipRateMe',
                },
              ],
            },
            showRateMe: {
              invoke: {
                src: 'showRateMePopup',
              },
              type: 'final',
            },
            skipRateMe: {
              type: 'final',
            },
          },
        },
      },
    },
    final: {
      type: 'final',
    },
  },
};
